"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
// Have only one entrypoint to highcharts and drill module
// Import this reexported variable in other files instead of direct import from highcharts
var highcharts_1 = tslib_1.__importDefault(require("highcharts"));
exports.default = highcharts_1.default;
//# sourceMappingURL=index.js.map